import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RetroTvError } from '../components/ui/RetroTvError';

export default function NotFound() {
  const navigate = useNavigate();

  const handleDesignClick = () => {
    navigate('/');
    setTimeout(() => {
      const simchaSection = document.querySelector('.simcha-section');
      if (simchaSection) {
        simchaSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <RetroTvError
      errorCode="404"
      errorMessage="404"
      onButtonClick={handleDesignClick}
    />
  );
}
